export default __webpack_public_path__ + "static/media/Support.8d207acc.svg";